import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/users";
import auth from "@/store/auth";
import attendance from "@/store/attendance";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    user,
    attendance,
  //   project,
  //   performance,
  //   task,
  //   notification,
  //   devision,
  //   monitoring,
  //   facinv,
  //   managerInventory,
  //   managerFacility,
  //   memberFacInv,
  //   adminBooking,
  //   note,
  //   holiday
  }
});